export default __webpack_public_path__ + "static/media/down_arrow.d465b78d.svg";